import { supportCameFromInstanceCustomDomain } from '@openx/utils/session/cameFromInstanceCustomDomain.ts';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { App } from './App.tsx';

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

supportCameFromInstanceCustomDomain();

root.render(
  <StrictMode>
    <BrowserRouter useTransitions={false}>
      <App />
    </BrowserRouter>
  </StrictMode>
);
